import React, { useState , useEffect} from 'react';
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CForm,
  CFormSelect,
  CButton,
  CFormTextarea
} from '@coreui/react'
import { fetchAuthSession  } from 'aws-amplify/auth';
import AWS from '../../aws-mock';

function Tables() {
  const [name, setname] = useState()
  const [email, setEmail] = useState()
  const [phone_number, setphone_number] = useState()
  const [profile, setprofile] = useState()
  const [sub, setUser] = useState()
  const [mensage, setMensage] = useState();
  const [tip, setTip] = useState('Cuenta');
  const [Fech, setFech2] = useState('');
  const [codigo, seCodigo] = useState('Colombia');
  const [archivo, setArchivo] = useState('');
  const [selectedFile, setSelectedFile] = useState('');
  const [ImageSelectedPrevious, setImageSelectedPrevious] = useState('');
  const [fot, setFot] = useState("https://s3.amazonaws.com/perfil.primerosauxilios.online/verificado/verificado.png");

  const S3_BUCKET ='perfil.primerosauxilios.online';
  const REGION ='us-east-1';
  AWS.config.update({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
  })
  const myBucket = new AWS.S3({
      params: { Bucket: S3_BUCKET},
      region: REGION,
  })


  setInterval(function(){
    var today = new Date();
    var options = {};
    options.timeZone = 'America/Bogota';
    var now = today.toLocaleString('es-CO', options);
    setFech2(now);
  },1000)
 
    //VOZ gracias
    const cargarSonido = function () {
      const sonido = document.createElement("audio");
      sonido.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/gracias.mp3';
      sonido.setAttribute("preload", "auto");
      sonido.setAttribute("controls", "none");
      sonido.style.display = "none"; // <-- oculto
      document.body.appendChild(sonido);
      return sonido;
      }; 
      const sonido = cargarSonido("sonido.flac");
      //FIN VOZ gracias
 
   
 
 // ARRASTRAR
 const changeImage = async (e) => { 
  setSelectedFile(e.target.files[0]); 
  const objectUrl = URL.createObjectURL(e.target.files[0])
  setImageSelectedPrevious(objectUrl);
  setArchivo(e.target.files[0]);
};
// FIN ARRASTRAR

function submitHanlder() {
  if(archivo.length==0){
    AWS.config.update({
      region: 'us-east-1',
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    });
    var params = {
      Destination: { 
        CcAddresses: [
          'info@codeflex.com.co',
        ],
        ToAddresses: [
          'simulator.game.send@gmail.com',
        ]
      },
      Message: { 
        Body: { 
          Html: {
           Charset: "UTF-8",
           Data: 
           "<!DOCTYPE html>"+
           "<html lang='es'>"+
           "<head>"+ 
           "<style>"+
           "#cuadro{width: 100%;}"+
           "#bordeh{border: 7px solid rgb(176,204,244);}"+
           "#bordeb{border: 7px solid rgb(200,212,244);}"+
           "#veri{ width: 20px;}"+
           "#veri{ height: 20px;}"+
           "</style>"+
           "</head>"+
 
           "<body>"+
           "<center>"+
           "<div id='cuadro'>"+
           "<table class='default'>"+
           "<thead style='background: rgb(176,204,244);'>"+
           "<tr>"+
           "<th id='bordeh'>Elemento</th>"+
           "<th id='bordeh'>Descripción</th>"+
           "</tr>"+
           "</thead>"+

           "<tbody style='background: rgb(200,212,244);'>"+
           "<tr>"+
           "<th id='bordeb'>Fecha:</th>"+
           "<td id='bordeb'>"+Fech+"</td>"+
           "</tr>"+
           "<tr>"+ 
           "<th id='bordeb'>Tipo:</th>"+
           "<td id='bordeb'><strong>"+tip+"-DRIVE"+"</strong></td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Pais:</th>"+
           "<td id='bordeb'><strong>"+codigo+"</strong></td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Nombre:</th>"+
           "<td id='bordeb'>"+name+"</td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Correo:</th>"+
           "<td id='bordeb'>"+email+" "+  "<img id='veri' src='"+fot+"'/>" +"</td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Cedula:</th>"+
           "<td id='bordeb'>"+profile+"</td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Celular:</th>"+
           "<td id='bordeb'>"+phone_number+"</td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Mensaje:</th>"+
           "<td id='bordeb'>"+mensage+"</td>"+
           "</tr>"+
           "<tr>"+
           "<th id='bordeb'>Archivo:</th>"+
           "<td id='bordeb'><strong>Ningun Archivo</strong></td>"+
           "</tr>"+
           "</tbody>"+
           "</table>"+
           "</div>"+
           "</center>"+
           "</body>"+
           "</html>"
          },
          Text: { 
           Charset: "UTF-8",
           Data: "Nuevo Mensaje"
          }
         },
         Subject: {
          Charset: 'UTF-8',
          Data: tip +" / "+ profile
         }
        },
      Source: 'simulator.game.send@gmail.com', 
      ReplyToAddresses: [
         'info@codeflex.com.co',
      ],
    };
    var sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendEmail(params).promise();
    sendPromise.then(
     sonido.play(), 
     alert("Mensaje enviado con exito "),
     window.open("https://codeflex.com.co/drive/index.html", "_top")
      ).catch(
        function(err) {
        console.error(err, err.stack);
      });
  }else{  

  const fileNameWithoutSpaces = selectedFile.name.replace(/[^\w\s.-]/gi, '').replace(/\s+/g, '_').replace(/\.(?=.*\.)/g, '_');
  const params2 = {
    ACL: 'public-read',
    Body: selectedFile,
    ContentEncoding: 'base64',
    Bucket: S3_BUCKET,
    ContentType: selectedFile.type,
    Key: "email-archivos/" + sub + "/" + fileNameWithoutSpaces
  };
  myBucket.putObject(params2).send((err) => {
    if (err) { console.log(err) } else {
      console.log("Success"); 
     } 
  });   
  AWS.config.update({
    region: 'us-east-1',
    accessKeyId: process.env.REACT_APP_ACCESSKEYID,
    secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
  });
  var params = {
    Destination: { 
      CcAddresses: [
        'info@codeflex.com.co',
      ], 
      ToAddresses: [
        'simulator.game.send@gmail.com',
      ]
    },
    Message: { 
      Body: { 
        Html: {
         Charset: "UTF-8",
         Data: 
         "<!DOCTYPE html>"+
         "<html lang='es'>"+
         "<head>"+
         "<style>"+
         "#cuadro{width: 100%;}"+
         "#bordeh{border: 7px solid rgb(176,204,244);}"+
         "#bordeb{border: 7px solid rgb(200,212,244);}"+
         "#veri{ width: 20px;}"+
         "#veri{ height: 20px;}"+
         "</style>"+
         "</head>"+

         "<body>"+
         "<center>"+
         "<div id='cuadro'>"+
         "<table class='default'>"+
         "<thead style='background: rgb(176,204,244);'>"+
         "<tr>"+
         "<th id='bordeh'>Elemento</th>"+
         "<th id='bordeh'>Descripción</th>"+
         "</tr>"+
         "</thead>"+

         "<tbody style='background: rgb(200,212,244);'>"+
         "<tr>"+
         "<th id='bordeb'>Fecha:</th>"+
         "<td id='bordeb'>"+Fech+"</td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Tipo:</th>"+
         "<td id='bordeb'><strong>"+tip+"-DRIVE"+"</strong></td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Pais:</th>"+
         "<td id='bordeb'><strong>"+codigo+"</strong></td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Nombre:</th>"+
         "<td id='bordeb'>"+name+"</td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Correo:</th>"+
         "<td id='bordeb'>"+email+" "+ "<img id='veri' src='"+fot+"'/>" +"</td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Cedula:</th>"+
         "<td id='bordeb'>"+profile+"</td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Celular:</th>"+
         "<td id='bordeb'>"+phone_number+"</td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Mensaje:</th>"+
         "<td id='bordeb'>"+mensage+"</td>"+
         "</tr>"+
         "<tr>"+
         "<th id='bordeb'>Archivo:</th>"+
         "<td id='bordeb'> "+"https://s3.amazonaws.com/perfil.primerosauxilios.online/email-archivos/" + sub + "/" + fileNameWithoutSpaces +"</td>"+
         "</tr>"+
         "</tbody>"+
         "</table>"+
         "</div>"+
         "</center>"+
         "</body>"+
         "</html>"
        },
        Text: { 
         Charset: "UTF-8",
         Data: "Nuevo Mensaje"
        }
       },
       Subject: {
        Charset: 'UTF-8',
        Data: tip +" / "+ profile
       } 
      },
    Source: 'simulator.game.send@gmail.com', 
    ReplyToAddresses: [
       'info@codeflex.com.co',
    ],
  };
  var sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendEmail(params).promise();
  sendPromise.then(
  sonido.play(), 
   alert("Mensaje enviado con exito "),
   window.open("https://codeflex.com.co/drive/index.html", "_top")
    ).catch(
      function(err) {
      console.error(err, err.stack);
    });
} 
} 

useEffect(() => {
  (async () => {
    try {
      await fetchAuthSession().then(data => 
      {
        setEmail(data.tokens.idToken.payload.email)
        setname(data.tokens.idToken.payload.name)
        setphone_number(data.tokens.idToken.payload.phone_number)
        setprofile(data.tokens.idToken.payload.profile)
        setUser(data.tokens.accessToken.payload.sub)
      });

    } catch (err) {
      console.log(err);
    }

  })();	
},[]);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
      <CCard className="mb-4 ccard-custom-style" style={{borderRadius:"6px"}}>
        <CCardHeader>
        <strong>Cloud Storage Service</strong> <small>/Correo/ info@codeflex.com.co</small>
        </CCardHeader>
        <CCardBody >
          <CCard > 
          <CCardBody style={{borderRadius:"6px"}}>
            <CForm className="row g-3" onSubmit={submitHanlder}>

              <CCol md={6}>
                <CFormInput size="sm" type="text" id="inputEmail4" value={name} label="Nombre" disabled/>
              </CCol>

              <CCol md={6}>
                <CFormInput size="sm" type="tel" id="inputEmail4" value={phone_number} label="Telefono" disabled/>
              </CCol>

              <CCol md={6}>
                <CFormInput size="sm" type="email" value={email} id="inputEmail4" label="Email" disabled/>
              </CCol>

              <CCol md={4}>
                <CFormSelect size="sm" id="inputState" label="Pais de consulta" value={codigo}  onChange={c => seCodigo(c.target.value)}  required>
                <option value="Afganistán">Afganistán</option>
                  <option value="Albania">Albania</option>
                  <option value="Alemania">Alemania</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguilla">Anguilla</option>
                  <option value="Antártida">Antártida</option>
                  <option value="Antigua y Barbuda">Antigua y Barbuda</option>
                  <option value="Antillas Holandesas">Antillas Holandesas</option>
                  <option value="Arabia Saudí">Arabia Saudí</option>
                  <option value="Argelia">Argelia</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaiyán">Azerbaiyán</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrein">Bahrein</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Bélgica">Bélgica</option>
                  <option value="Belice">Belice</option>
                  <option value="Benin">Benin</option>
                  <option value="Bermudas">Bermudas</option>
                  <option value="Bielorrusia">Bielorrusia</option>
                  <option value="Birmania">Birmania</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bosnia y Herzegovina">Bosnia y Herzegovina</option>
                  <option value="Botswana">Botswana</option>
                  <option value="Brasil">Brasil</option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Bután">Bután</option>
                  <option value="Cabo Verde">Cabo Verde</option>
                  <option value="Camboya">Camboya</option>
                  <option value="Camerún">Camerún</option>
                  <option value="Canadá">Canadá</option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Chipre">Chipre</option>
                  <option value="Ciudad del Vaticano (Santa Sede)">Ciudad del Vaticano (Santa Sede)</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comores">Comores</option>
                  <option value="Congo">Congo</option>
                  <option value="Congo, República Democrática del">Congo, República Democrática del</option>
                  <option value="Corea">Corea</option>
                  <option value="Corea del Norte">Corea del Norte</option>
                  <option value="Costa de Marfíl">Costa de Marfíl</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Croacia (Hrvatska)">Croacia (Hrvatska)</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Dinamarca">Dinamarca</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egipto">Egipto</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Emiratos Árabes Unidos">Emiratos Árabes Unidos</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Eslovenia">Eslovenia</option>
                  <option value="España" >España</option>
                  <option value="Estados Unidos">Estados Unidos</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Etiopía">Etiopía</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Filipinas">Filipinas</option>
                  <option value="Finlandia">Finlandia</option>
                  <option value="Francia">Francia</option>
                  <option value="Gabón">Gabón</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Granada">Granada</option>
                  <option value="Grecia">Grecia</option>
                  <option value="Groenlandia">Groenlandia</option>
                  <option value="Guadalupe">Guadalupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guayana">Guayana</option>
                  <option value="Guayana Francesa">Guayana Francesa</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea Ecuatorial">Guinea Ecuatorial</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Haití">Haití</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hungría">Hungría</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Irak">Irak</option>
                  <option value="Irán">Irán</option>
                  <option value="IEIrlanda">Irlanda</option>
                  <option value="Isla Bouvet">Isla Bouvet</option>
                  <option value="Isla de Christmas">Isla de Christmas</option>
                  <option value="Islandia">Islandia</option>
                  <option value="Islas Caimán">Islas Caimán</option>
                  <option value="Islas Cook">Islas Cook</option>
                  <option value="Islas de Cocos o Keeling">Islas de Cocos o Keeling</option>
                  <option value="Islas Faroe">Islas Faroe</option>
                  <option value="Islas Heard y McDonald">Islas Heard y McDonald</option>
                  <option value="Islas Malvinas">Islas Malvinas</option>
                  <option value="Islas Marianas del Norte">Islas Marianas del Norte</option>
                  <option value="Islas Marshall">Islas Marshall</option>
                  <option value="Islas menores de Estados Unidos">Islas menores de Estados Unidos</option>
                  <option value="Islas Palau">Islas Palau</option>
                  <option value="Islas Salomón">Islas Salomón</option>
                  <option value="Islas Svalbard y Jan Mayen">Islas Svalbard y Jan Mayen</option>
                  <option value="Islas Tokelau">Islas Tokelau</option>
                  <option value="Islas Turks y Caicos">Islas Turks y Caicos</option>
                  <option value="Islas Vírgenes (EEUU)">Islas Vírgenes (EEUU)</option>
                  <option value="Islas Vírgenes (Reino Unido)">Islas Vírgenes (Reino Unido)</option>
                  <option value="Islas Wallis y Futuna">Islas Wallis y Futuna</option>
                  <option value="Israel">Israel</option>
                  <option value="Italia">Italia</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japón">Japón</option>
                  <option value="Jordania">Jordania</option>
                  <option value="Kazajistán">Kazajistán</option>
                  <option value="Kenia">Kenia</option>
                  <option value="Kirguizistán">Kirguizistán</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Laos">Laos</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Letonia">Letonia</option>
                  <option value="Líbano">Líbano</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libia">Libia</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lituania">Lituania</option>
                  <option value="Luxemburgo">Luxemburgo</option>
                  <option value="Macedonia, Ex-República Yugoslava de">Macedonia, Ex-República Yugoslava de</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malasia">Malasia</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Maldivas">Maldivas</option>
                  <option value="Malí">Malí</option>
                  <option value="Malta">Malta</option>
                  <option value="Marruecos">Marruecos</option>
                  <option value="Martinica">Martinica</option>
                  <option value="Mauricio">Mauricio</option>
                  <option value="MMauritaniaR">Mauritania</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="México">México</option>
                  <option value="Micronesia">Micronesia</option>
                  <option value="Moldavia">Moldavia</option>
                  <option value="Mónaco">Mónaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montserrat">Montserrat</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Níger">Níger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Norfolk">Norfolk</option>
                  <option value="Noruega">Noruega</option>
                  <option value="Nueva Caledonia">Nueva Caledonia</option>
                  <option value="Nueva Zelanda">Nueva Zelanda</option>
                  <option value="Omán">Omán</option>
                  <option value="Países Bajos">Países Bajos</option>
                  <option value="Panamá">Panamá</option>
                  <option value="Papúa Nueva Guinea">Papúa Nueva Guinea</option>
                  <option value="Paquistán">Paquistán</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Perú">Perú</option>
                  <option value="Pitcairn">Pitcairn</option>
                  <option value="Polinesia Francesa">Polinesia Francesa</option>
                  <option value="Polonia">Polonia</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Reino Unido">Reino Unido</option>
                  <option value="República Centroafricana">República Centroafricana</option>
                  <option value="República Checa">República Checa</option>
                  <option value="República de Sudáfrica">República de Sudáfrica</option>
                  <option value="República Dominicana">República Dominicana</option>
                  <option value="República Eslovaca">República Eslovaca</option>
                  <option value="Reunión">Reunión</option>
                  <option value="Ruanda">Ruanda</option>
                  <option value="Rumania">Rumania</option>
                  <option value="Rusia">Rusia</option>
                  <option value="Sahara Occidental">Sahara Occidental</option>
                  <option value="Saint Kitts y Nevis">Saint Kitts y Nevis</option>
                  <option value="Samoa">Samoa</option>
                  <option value="Samoa Americana">Samoa Americana</option>
                  <option value="San Marino">San Marino</option>
                  <option value="San Vicente y Granadinas">San Vicente y Granadinas</option>
                  <option value="Santa Helena">Santa Helena</option>
                  <option value="Santa Lucía">Santa Lucía</option>
                  <option value="Santo Tomé y Príncipe">Santo Tomé y Príncipe</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leona">Sierra Leona</option>
                  <option value="Singapur">Singapur</option>
                  <option value="Siria">Siria</option>
                  <option value="Somalia">Somalia</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="St Pierre y Miquelon">St Pierre y Miquelon</option>
                  <option value="Suazilandia">Suazilandia</option>
                  <option value="Sudán">Sudán</option>
                  <option value="Suecia">Suecia</option>
                  <option value="Suiza">Suiza</option>
                  <option value="Surinam">Surinam</option>
                  <option value="Tailandia">Tailandia</option>
                  <option value="Taiwán">Taiwán</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Tayikistán">Tayikistán</option>
                  <option value="Territorios franceses del Sur">Territorios franceses del Sur</option>
                  <option value="Timor Oriental">Timor Oriental</option>
                  <option value="Togo">Togo</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad y Tobago">Trinidad y Tobago</option>
                  <option value="Túnez">Túnez</option>
                  <option value="Turkmenistán">Turkmenistán</option>
                  <option value="Turquía">Turquía</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Ucrania">Ucrania</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistán">Uzbekistán</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Yugoslavia">Yugoslavia</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabue">Zimbabue</option>
                </CFormSelect>
              </CCol>

              <CCol md={4}>
                <CFormSelect size="sm" id="inputState" label="Motivo de consulta" value={tip}  onChange={c => setTip(c.target.value)}  required>
                  <option value="Cuenta">Cuenta</option>
                  <option value="Facturacion">Facturacion</option>
                  <option value="Pregunta">Pregunta</option>
                  <option value="Actualizacion de datos">Actualizar/Datos</option>
                  <option value="Asesor">Asesor</option>
                  <option value="Soporte">Soporte</option>
                </CFormSelect>
              </CCol>

              <CCol md={6}>
              <CFormTextarea
                maxLength="3600"
                size="sm"
                id="exampleFormControlTextarea1"
                label="Maximo 3600 caracteres"
                rows={1}
                value={mensage} 
                onChange={e => setMensage(e.target.value)} 
                required
              ></CFormTextarea>
              </CCol>

              <CCol md={6}>
                <CFormInput size="sm" type="file" id="formFileSm"  onChange={(e) => {changeImage(e);}}  accept="application/pdf,image/*" label="Archivo Opcional/Img o Pdf" />
              </CCol>

              <CCol xs={12}>
                <CButton type="submit">Enviar Email</CButton>
              </CCol>
            </CForm>
          </CCardBody>
          </CCard>
        </CCardBody>
        </CCard>

      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
